// extracted by mini-css-extract-plugin
export var deleteIcon = "_tg-5";
export var deleteOption = "_tg-3";
export var divider = "_tg-2";
export var downloadIcon = "_tg-4";
export var drawer = "_tg-0";
export var drawerFooter = "_tg-6";
export var drawerOpen = "_tg-1";
export var highlighted = "_tg-7";
export var lighterHighlight = "_tg-8";